import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

import { AppShellComponent } from './app-shell/app-shell.component';
import { ForgotComponent } from './auth/forgot/forgot.component';
import { LoginComponent } from './auth/login/login.component';
import { NewPasswordComponent } from './auth/new-password/new-password.component';
import { UnauthorisedComponent } from './auth/unauthorised/unauthorised.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { TestPageComponent } from './test-page/test-page.component';
import { LocationStatusComponent } from './location-status/location-status.component';
import { GatewayStatusComponent } from './gateway-status/gateway-status.component';
import { NodeGraphComponent } from './location-status/node-graphs/node-graph.component';
import { GatewayReportComponent } from './gateway-status/reports/gateway-report.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';

const appRoutes: Routes = [
  // unprotected routes which must be accessible even if user has no session
  { path: 'signin', component: LoginComponent },
  { path: 'new-password', component: NewPasswordComponent },
  { path: 'forgot-password', component: ForgotComponent },
  { path: 'unauthorised', component: UnauthorisedComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  // POC is here as we don't want it to be wrapped by AppShellComponent
  {
    path: 'poc/:locationId/:roomId',
    loadChildren: './dashboard-controls-only/dashboard.module#DashboardModule',
    canActivateChild: [AuthGuard]
  },
  // TODO: refactor the structure, note that AppShell now the parent of our locationsModule
  // and locationsModule is a mish-mash of all the Dashboard stuff
  // the way our routing has been structured, every non-login route is child of '/'
  {
    path: '',
    component: AppShellComponent,
    canActivateChild: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'notifications',
        component: NotificationsComponent
      },
      {
        path: 'test-page',
        component: TestPageComponent
      },
      {
        path: 'location-status/:locationid',
        component: LocationStatusComponent
      },
      {
        path: 'location-status',
        component: LocationStatusComponent
      },
      {
        path: 'location-status/node-graphs/:nodeId',
        component: NodeGraphComponent
      },
      {
        path: 'gateway-setup',
        loadChildren: './gateway-setup/gateway-setup.module#GatewaySetupModule'
      },
      {
        path: 'gateway-status',
        component: GatewayStatusComponent
      },
      {
        path: 'gateway-status/reports/:gatewayId',
        component: GatewayReportComponent
      },
      {
        path: 'locations',
        loadChildren: './locations/locations.module#LocationsModule',
        data: {
          title: 'Locations'
        }
      }
    ]
  },
  { path: '**', redirectTo: 'unauthorised' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/app-routing.modules.ts